import { SxProps } from '@mui/material';

export const styledBox = {
  bgcolor: 'white',
  border: '1px solid #eaeaf7',
  boxShadow: '0px 0px 20px 5px rgba(44, 47, 240, 0.08)',
} satisfies SxProps;
